import React, { useEffect, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import api from '../api/axios';
import { FiLogIn } from 'react-icons/fi';

/**
 * Exchanges a one-time platform auto-login token (?t=) for a real auth token,
 * then hard-redirects to the dashboard so the auth store rehydrates from
 * localStorage. Used by the Hadaq app's "Control Panel" button.
 */
export default function AutoLoginPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('t') || '';
  const [error, setError] = useState(false);
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;

    if (!token) {
      setError(true);
      return;
    }

    (async () => {
      try {
        const res = await api.post('/platform-login', { token });
        const { user, token: authToken } = res.data;
        if (!authToken) throw new Error('no token');
        localStorage.setItem('token', authToken);
        localStorage.setItem('user', JSON.stringify(user));
        // Full reload so the auth store picks up the token from localStorage.
        window.location.replace('/dashboard');
      } catch {
        setError(true);
      }
    })();
  }, [token]);

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f9fafb' }}>
      <div style={{ textAlign: 'center', maxWidth: 420, padding: 40, background: '#fff', borderRadius: 16, boxShadow: '0 4px 24px rgba(0,0,0,0.06)' }}>
        <div style={{ width: 56, height: 56, borderRadius: '50%', background: '#e0e7ff', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px' }}>
          <FiLogIn size={24} color="#4f46e5" />
        </div>
        {error ? (
          <>
            <h2 style={{ margin: 0, fontSize: 20, fontWeight: 700 }}>تعذّر تسجيل الدخول</h2>
            <p style={{ color: '#666', fontSize: 14, marginTop: 8 }}>
              انتهت صلاحية رابط الدخول أو أنه غير صالح. يرجى المحاولة مرة أخرى من تطبيق حداق.
            </p>
            <a
              href="/login"
              style={{ display: 'inline-block', marginTop: 16, padding: '10px 20px', background: '#4f46e5', color: '#fff', borderRadius: 8, textDecoration: 'none', fontSize: 14, fontWeight: 600 }}
            >
              تسجيل الدخول يدوياً
            </a>
          </>
        ) : (
          <>
            <h2 style={{ margin: 0, fontSize: 20, fontWeight: 700 }}>جاري تسجيل الدخول…</h2>
            <p style={{ color: '#666', fontSize: 14, marginTop: 8 }}>يتم فتح لوحة تحكم متجرك</p>
            <div
              style={{
                width: 28, height: 28, margin: '20px auto 0', border: '3px solid #e0e7ff',
                borderTopColor: '#4f46e5', borderRadius: '50%', animation: 'spin 0.8s linear infinite',
              }}
            />
            <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
          </>
        )}
      </div>
    </div>
  );
}
